import { render, staticRenderFns } from "./histogramChart.vue?vue&type=template&id=33360208&scoped=true"
import script from "./histogramChart.vue?vue&type=script&lang=js"
export * from "./histogramChart.vue?vue&type=script&lang=js"
import style0 from "./histogramChart.vue?vue&type=style&index=0&id=33360208&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33360208",
  null
  
)

export default component.exports